import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const useCustomHeader = () => {
  const page = useSelector(select.cms.getPage);
  const isNavV2Enabled = useFeature(FeatureFlag.PKRNavDesignV2);
  const isNavV3Enabled = useFeature(FeatureFlag.PKRNavDesignV3);

  return {
    lightHeader: ['light', 'custom-light'].includes(page?.custom_header || ''),
    prospectHeader: page?.custom_header === 'prospect',
    headerV2: isNavV2Enabled || page?.custom_header === 'header-v2',
    headerV3: isNavV3Enabled || page?.custom_header === 'header-v3',
    clickableLogoUrl: page?.clickable_logo_url,
    headerLink: page?.content[0]?.header_link,
    showLocalesDropdown:
      page?.custom_header === 'custom-light' &&
      page?.custom_light_header_options?.includes('Locales Dropdown')
  };
};

export default useCustomHeader;
